module.exports = __webpack_public_path__ + "static/media/webd7.0325f5bf.jpg";